module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Chat":"Chat","Chat now":"Chat now","Type a message":"Type a message","Send":"Send"},"zh":{"Chat":"互动消息","Chat now":"快来互动吧","Type a message":"说点什么","Send":"发送"}}')
  delete Component.options._Ctor
}
